import { AxiosError } from "axios";

import { useMutation } from "@enkor/react-query";

import BaseApi from "@logics/api/baseApi";
import {
  RequestCreateFipUser,
  RequestFipCheckEmail,
  RequestFipLogin,
  ResponseFipCheckEmail,
  ResponseUserTokenRefreshFip,
} from "@models/auth/data-contracts";
import { ApiResponseDto, ErrorResponseType } from "@models/client";
import AuthBaseApi from "@logics/api/authBaseApi";

const authApi = new AuthBaseApi("/fip");
const userApi = new BaseApi("/user");

// ------------------------------------------------------------------------

export const useCreateCheckEmailMutation = () => {
  return useMutation({
    mutationFn: async ({ email }: RequestFipCheckEmail) => {
      const { data } = await authApi.post<
        ApiResponseDto<ResponseFipCheckEmail>
      >("/check-email", {
        email,
      });

      return data.existYn === "Y";
    },
  });
};

// ------------------------------------------------------------------------

export const useCreateLoginMutation = () => {
  return useMutation<
    ApiResponseDto<ResponseUserTokenRefreshFip>,
    AxiosError<ErrorResponseType>,
    RequestFipLogin
  >({
    mutationFn: ({ email, password }: RequestFipLogin) =>
      authApi.post<ApiResponseDto<ResponseUserTokenRefreshFip>>("/login", {
        email,
        password,
      }),
  });
};

// ------------------------------------------------------------------------

export const useCreateRegisterMutation = () => {
  return useMutation<
    ApiResponseDto<unknown>,
    AxiosError<ErrorResponseType>,
    RequestCreateFipUser
  >({
    mutationFn: (data: Pick<RequestCreateFipUser, "email" | "password">) =>
      authApi.post<ApiResponseDto<unknown>>("/user", {
        ...data,
        authProvider: "native",
      }),
  });
};

// ------------------------------------------------------------------------

export const useDeleteAccountMutation = () => {
  return useMutation({
    mutationFn: (data: { content: string }) =>
      userApi.delete("/withdraw", {
        data,
      }),
  });
};
